import { render, staticRenderFns } from "./recordAuditDialog.vue?vue&type=template&id=7f870c20&scoped=true&"
import script from "./recordAuditDialog.vue?vue&type=script&lang=js&"
export * from "./recordAuditDialog.vue?vue&type=script&lang=js&"
import style0 from "./recordAuditDialog.vue?vue&type=style&index=0&id=7f870c20&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f870c20",
  null
  
)

export default component.exports